import Rate from './src/rate2.mjs';
export { rateEmits, rateProps } from './src/rate.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElRate = withInstall(Rate);

export { ElRate, ElRate as default };
//# sourceMappingURL=index.mjs.map
